// extracted by mini-css-extract-plugin
export default {"footer":"style_footer__RMWUs","inner":"style_inner__HUhN4","footer_links":"style_footer_links__QkYWW"};